import React from 'react';
import { render } from 'inferno';
import asyncEach from 'async/each';
import asyncEachSeries from 'async/eachSeries';
import asyncSeries from 'async/series';

import App from './app';

import Analytics from './tools/analytics';
import util from './tools/util';

const SCRIPT_LIST = [];
const CSS_LIST = [];

console.log('harbour-exchange-app:', process.env.VERSION);
function _onLoad() {
  if (window.isUnsupportedBrowser) {
    return;
  }

  const is_local =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.origin.indexOf(':3003') !== -1 ||
    window.location.origin.indexOf(':8080') !== -1;

  if (is_local && window.location.hash === '#mock') {
    util.log('_onLoad: Test server added mock-app-container class');
    document.body.classList.add('mock-app-container');
  } else if (is_local && window.location.hash === '#mock-wide') {
    util.log('_onLoad: Test server added mock-app-container wide class');
    document.body.classList.add('mock-app-container-wide');
  }

  _preStartApp();
}
window.onload = _onLoad;

function _preStartApp() {
  Analytics.preInit();
  util.setDebugLogger(Analytics.log);

  _loadAssets(() => {
    startApp();
  });
}

function _loadAssets(done) {
  asyncSeries(
    [
      (done) => {
        _loadScripts(() => {}, done);
      },
      (done) => {
        _loadStyles(() => {}, done);
      },
    ],
    () => {
      done();
    }
  );
}

function _loadScripts(progress_cb, done) {
  asyncEachSeries(
    SCRIPT_LIST,
    (script, done) => {
      _loadScript(script, (err) => {
        if (err) {
          util.errorLog('init: _loadScript: err:', err, 'script:', script);
        }
        progress_cb();
        done();
      });
    },
    done
  );
}
function _loadStyles(progress_cb, done) {
  asyncEach(
    CSS_LIST,
    (href, done) => {
      _loadCSS(href, (err) => {
        if (err) {
          util.errorLog('init: _loadStyles: err:', err, 'href:', href);
        }
        progress_cb();
        done();
      });
    },
    done
  );
}

function startApp() {
  const element = document.getElementById('react-root');
  render(<App />, element);
}

function _loadScript(url, done) {
  const new_script = document.createElement('script');
  new_script.onerror = done;
  new_script.onload = (e) => done(null, e);
  document.head.appendChild(new_script);
  new_script.src = url;
}

function _loadCSS(href, done) {
  const new_link = document.createElement('link');
  new_link.rel = 'stylesheet';
  new_link.type = 'text/css';
  new_link.onerror = done;
  new_link.onload = (e) => done(null, e);
  new_link.href = href;
  document.head.appendChild(new_link);
}
